import { type IPost } from 'types/interfaces/ITypes'

import { AudioUnderPost } from '../AudioUnderPost/AudioUnderPost'

export interface SoundsProps {
    postData: IPost
}

export const Sounds = ({ postData }: SoundsProps) => {
    if (!postData.sounds.length) return null

    return (
        <div className='post-sound-container'>
            {postData?.sounds.map((sound: any) =>
                sound.url ? (
                    <AudioUnderPost mediaUrl={sound.url} key={sound.id} />
                ) : null
            )}
        </div>
    )
}
